export default "__VITE_ASSET__84dc246d__"